import makeStyles from "@mui/styles/makeStyles";

const usersPanelSurface =
	"linear-gradient(180deg, var(--atl-surface-solid-strong) 0%, var(--atl-surface-solid) 100%)";
const usersInnerSurface =
	"linear-gradient(180deg, var(--atl-surface-solid-muted) 0%, var(--atl-surface-solid) 100%)";
const usersSelectedSurface =
	"linear-gradient(135deg, color-mix(in srgb, var(--atl-blue) 13%, var(--atl-surface-solid-strong)) 0%, color-mix(in srgb, var(--atl-teal) 10%, var(--atl-surface-solid)) 100%)";
const usersAccentSurface =
	"linear-gradient(135deg, color-mix(in srgb, var(--user-accent) 12%, var(--atl-surface-solid-strong)) 0%, color-mix(in srgb, var(--user-accent-2) 10%, var(--atl-surface-solid)) 100%)";

export const UserStyle = makeStyles((theme) => ({
	page: {},
	container: {
		position: "relative",
		zIndex: 1,
		paddingTop: theme.spacing(3),
		[theme.breakpoints.down("sm")]: {
			paddingTop: theme.spacing(2),
			paddingLeft: theme.spacing(1.5),
			paddingRight: theme.spacing(1.5),
		},
	},
	hero: {
		display: "flex",
		alignItems: "flex-end",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		marginBottom: theme.spacing(2),
		padding: theme.spacing(3),
		border: "1px solid var(--atl-border)",
		borderRadius: 24,
		color: "#fff",
		background:
			"linear-gradient(135deg, color-mix(in srgb, var(--atl-blue) 88%, #000 0%) 0%, color-mix(in srgb, var(--atl-teal) 84%, #000 0%) 100%)",
		boxShadow: "var(--atl-shadow-strong)",
		overflow: "hidden",
		position: "relative",
		"&:before": {
			content: '""',
			position: "absolute",
			inset: 0,
			background:
				"radial-gradient(circle at 86% 18%, rgba(255,255,255,0.22), transparent 0 170px), linear-gradient(180deg, rgba(255,255,255,0.14), rgba(255,255,255,0))",
			pointerEvents: "none",
		},
		"& > *": {
			position: "relative",
			zIndex: 1,
		},
		[theme.breakpoints.down("sm")]: {
			alignItems: "stretch",
			flexDirection: "column",
			padding: theme.spacing(2.25),
		},
	},
	eyebrow: {
		marginBottom: theme.spacing(1),
		fontSize: 12,
		fontWeight: 900,
		letterSpacing: "0.08em",
		textTransform: "uppercase",
		opacity: 0.82,
	},
	heroTitle: {
		maxWidth: 780,
		color: "#fff",
		fontSize: 38,
		fontWeight: 900,
		lineHeight: 1.05,
		[theme.breakpoints.down("sm")]: {
			fontSize: 30,
		},
	},
	heroSubtitle: {
		maxWidth: 700,
		marginTop: theme.spacing(1.25),
		color: "rgba(255,255,255,0.8)",
		fontSize: 15,
		fontWeight: 650,
		lineHeight: 1.45,
	},
	heroStats: {
		display: "grid",
		gridTemplateColumns: "repeat(3, minmax(96px, 1fr))",
		gap: theme.spacing(1),
		minWidth: 360,
		[theme.breakpoints.down("md")]: {
			minWidth: 0,
			gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
		},
		"@media (max-width: 420px)": {
			gridTemplateColumns: "1fr",
		},
	},
	heroStat: {
		padding: theme.spacing(1.25),
		border: "1px solid rgba(255,255,255,0.24)",
		borderRadius: 18,
		background: "rgba(255,255,255,0.12)",
		boxShadow: "inset 0 1px 0 rgba(255,255,255,0.18)",
	},
	statLabel: {
		color: "rgba(255,255,255,0.72)",
		fontSize: 12,
		fontWeight: 900,
		textTransform: "uppercase",
	},
	statValue: {
		color: "#fff",
		fontSize: 22,
		fontWeight: 900,
		lineHeight: 1,
	},
	searchPanel: {
		marginBottom: theme.spacing(2),
		padding: theme.spacing(1.5),
		border: "1px solid var(--atl-border)",
		borderRadius: 22,
		background: usersPanelSurface,
		boxShadow: "var(--atl-shadow), inset 0 1px 0 var(--atl-surface-solid-strong)",
	},
	searchField: {
		"& .MuiInputBase-root": {
			borderRadius: "18px !important",
			background: "var(--atl-surface-solid) !important",
			color: "var(--atl-text) !important",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "var(--atl-border) !important",
		},
		"& .MuiInputBase-input": {
			fontSize: "15px !important",
			fontWeight: "700 !important",
		},
	},
	contentShell: {
		display: "grid",
		gridTemplateColumns: "280px minmax(0, 1fr)",
		gap: theme.spacing(2),
		alignItems: "start",
		[theme.breakpoints.down("md")]: {
			gridTemplateColumns: "1fr",
		},
	},
	drawer: {
		position: "sticky",
		top: theme.spacing(1.5),
		display: "grid",
		gap: theme.spacing(1.25),
		padding: theme.spacing(1.5),
		border: "1px solid var(--atl-border)",
		borderRadius: 22,
		background: usersPanelSurface,
		boxShadow: "var(--atl-shadow), inset 0 1px 0 var(--atl-surface-solid-strong)",
		[theme.breakpoints.down("md")]: {
			position: "relative",
			top: 0,
		},
	},
	drawerHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(1),
	},
	drawerTitle: {
		color: "var(--atl-text)",
		fontSize: 15,
		fontWeight: 900,
		lineHeight: 1.2,
	},
	drawerSubtitle: {
		marginTop: 2,
		color: "var(--atl-text-soft)",
		fontSize: 12,
		fontWeight: 700,
		lineHeight: 1.3,
	},
	companyList: {
		display: "grid",
		gap: theme.spacing(0.75),
		maxHeight: "min(520px, calc(100vh - 260px))",
		overflowY: "auto",
		paddingTop: theme.spacing(0.35),
		paddingRight: 2,
		paddingBottom: theme.spacing(0.35),
		scrollbarWidth: "none",
		"&::-webkit-scrollbar": {
			display: "none",
		},
		[theme.breakpoints.down("md")]: {
			gridAutoColumns: "minmax(220px, 1fr)",
			gridAutoFlow: "column",
			overflowX: "auto",
			overflowY: "hidden",
			maxHeight: "none",
			paddingBottom: theme.spacing(0.5),
		},
	},
	companyButton: {
		display: "grid",
		gridTemplateColumns: "38px minmax(0, 1fr)",
		gap: theme.spacing(1),
		alignItems: "center",
		width: "100%",
		minWidth: 0,
		padding: theme.spacing(1),
		border: "1px solid var(--atl-border)",
		borderRadius: 16,
		color: "var(--atl-text)",
		background: usersInnerSurface,
		boxShadow: "inset 0 1px 0 var(--atl-surface-solid-strong)",
		cursor: "pointer",
		textAlign: "left",
		transition: "border-color 0.18s ease, background 0.18s ease, transform 0.18s ease",
		"&:hover": {
			transform: "translateY(-1px)",
			borderColor: "color-mix(in srgb, var(--atl-blue) 35%, var(--atl-border))",
		},
	},
	companyButtonSelected: {
		borderColor: "color-mix(in srgb, var(--atl-blue) 48%, var(--atl-border))",
		background: usersSelectedSurface,
	},
	companyAvatar: {
		width: "38px !important",
		height: "38px !important",
		background: "var(--atl-surface-solid) !important",
	},
	companyName: {
		color: "var(--atl-text)",
		fontSize: 13,
		fontWeight: 850,
		lineHeight: 1.2,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	companyMeta: {
		marginTop: 2,
		color: "var(--atl-text-soft)",
		fontSize: 11,
		fontWeight: 700,
	},
	usersPanel: {
		minWidth: 0,
		padding: theme.spacing(2),
		border: "1px solid var(--atl-border)",
		borderRadius: 22,
		background: usersPanelSurface,
		boxShadow: "var(--atl-shadow), inset 0 1px 0 var(--atl-surface-solid-strong)",
	},
	usersPanelHeader: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: theme.spacing(1.5),
		marginBottom: theme.spacing(1.5),
		[theme.breakpoints.down("sm")]: {
			flexDirection: "column",
		},
	},
	panelTitle: {
		color: "var(--atl-text)",
		fontSize: 20,
		fontWeight: 900,
		lineHeight: 1.15,
	},
	panelSubtitle: {
		marginTop: 4,
		color: "var(--atl-text-soft)",
		fontSize: 13,
		fontWeight: 700,
		lineHeight: 1.35,
	},
	resultPill: {
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		minHeight: 32,
		padding: theme.spacing(0.5, 1),
		borderRadius: 999,
		color: "var(--atl-text)",
		background: "var(--atl-surface-solid)",
		border: "1px solid var(--atl-border)",
		fontSize: 12,
		fontWeight: 850,
		whiteSpace: "nowrap",
	},
	usersGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(3, minmax(240px, 1fr))",
		gap: theme.spacing(1.25),
		[theme.breakpoints.down("lg")]: {
			gridTemplateColumns: "repeat(2, minmax(220px, 1fr))",
		},
		[theme.breakpoints.down("sm")]: {
			gridTemplateColumns: "1fr",
		},
	},
	userCard: {
		position: "relative",
		display: "grid",
		gridTemplateColumns: "52px minmax(0, 1fr)",
		gap: theme.spacing(1.25),
		alignItems: "start",
		minHeight: 142,
		padding: theme.spacing(1.5),
		border: "1px solid var(--atl-border)",
		borderRadius: 18,
		color: "var(--atl-text)",
		background: usersInnerSurface,
		boxShadow: "inset 0 1px 0 var(--atl-surface-solid-strong)",
		cursor: "pointer",
		overflow: "hidden",
		textAlign: "left",
		transition: "transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease",
		"&:before": {
			content: '""',
			position: "absolute",
			inset: 0,
			opacity: 0,
			background: usersAccentSurface,
			transition: "opacity 0.18s ease",
			pointerEvents: "none",
		},
		"&:hover": {
			transform: "translateY(-2px)",
			borderColor: "color-mix(in srgb, var(--user-accent) 36%, var(--atl-border))",
			boxShadow: "var(--atl-shadow-strong)",
			"&:before": {
				opacity: 1,
			},
		},
	},
	userCardDeleted: {
		borderColor: "color-mix(in srgb, var(--atl-red) 45%, var(--atl-border))",
	},
	userAvatarWrap: {
		position: "relative",
		zIndex: 1,
	},
	userAvatar: {
		width: "52px !important",
		height: "52px !important",
		background: "var(--atl-surface-solid) !important",
		boxShadow: "0 8px 18px color-mix(in srgb, var(--user-accent) 20%, transparent)",
	},
	onlineDot: {
		position: "absolute",
		right: 1,
		bottom: 2,
		width: 13,
		height: 13,
		borderRadius: 999,
		background: "var(--atl-green)",
		border: "2px solid var(--atl-surface-solid)",
		boxShadow: "0 0 0 4px color-mix(in srgb, var(--atl-green) 16%, transparent)",
	},
	userCardBody: {
		position: "relative",
		zIndex: 1,
		minWidth: 0,
	},
	userCardTop: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: theme.spacing(1),
		minWidth: 0,
	},
	userAlias: {
		color: "var(--atl-text)",
		fontSize: 15,
		fontWeight: 900,
		lineHeight: 1.2,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	statusPill: {
		display: "inline-flex",
		alignItems: "center",
		flex: "0 0 auto",
		padding: theme.spacing(0.35, 0.7),
		borderRadius: 999,
		color: "var(--atl-text)",
		background: "var(--atl-surface-solid)",
		border: "1px solid var(--atl-border)",
		fontSize: 11,
		fontWeight: 850,
		lineHeight: 1,
	},
	statusPillDeleted: {
		color: "var(--atl-red)",
		borderColor: "color-mix(in srgb, var(--atl-red) 34%, var(--atl-border))",
	},
	userMeta: {
		marginTop: 4,
		color: "var(--atl-text-soft)",
		fontSize: 12,
		fontWeight: 700,
		lineHeight: 1.35,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	rolePreview: {
		display: "flex",
		flexWrap: "wrap",
		gap: 5,
		marginTop: theme.spacing(1),
	},
	roleChip: {
		maxWidth: "100%",
		height: "24px !important",
		borderRadius: "999px !important",
		border: "1px solid color-mix(in srgb, var(--role-color) 42%, var(--atl-border)) !important",
		background: "color-mix(in srgb, var(--role-color) 12%, var(--atl-surface-solid)) !important",
		color: "var(--atl-text) !important",
		fontSize: "11px !important",
		fontWeight: "850 !important",
		"& .MuiChip-label": {
			overflow: "hidden",
			textOverflow: "ellipsis",
		},
	},
	emptyState: {
		padding: theme.spacing(3),
		borderRadius: 18,
		color: "var(--atl-text-soft)",
		background: usersInnerSurface,
		border: "1px solid var(--atl-border)",
		fontSize: 14,
		fontWeight: 750,
		textAlign: "center",
	},
	skeletonCard: {
		height: 142,
		borderRadius: "18px !important",
		background: "var(--atl-surface-solid-muted) !important",
	},
	dialogContent: {
		display: "grid",
		gap: theme.spacing(1.5),
	},
	dialogSummaryGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
		gap: theme.spacing(1),
		[theme.breakpoints.down("sm")]: {
			gridTemplateColumns: "1fr",
		},
	},
	dialogFact: {
		padding: theme.spacing(1),
		borderRadius: 16,
		border: "1px solid var(--atl-border)",
		background: usersInnerSurface,
		minWidth: 0,
	},
	dialogFactLabel: {
		color: "var(--atl-text-soft)",
		fontSize: 11,
		fontWeight: 900,
		textTransform: "uppercase",
	},
	dialogFactValue: {
		display: "block",
		marginTop: 3,
		color: "var(--atl-text)",
		fontSize: 13,
		fontWeight: 800,
		lineHeight: 1.25,
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	dialogSection: {
		display: "grid",
		gap: theme.spacing(1),
		padding: theme.spacing(1.25),
		borderRadius: 18,
		border: "1px solid var(--atl-border)",
		background: usersInnerSurface,
	},
	dialogSectionTitle: {
		color: "var(--atl-text)",
		fontSize: 14,
		fontWeight: 900,
		lineHeight: 1.2,
	},
	dialogRoles: {
		display: "flex",
		flexWrap: "wrap",
		gap: 6,
	},
	dialogRoleField: {
		"& .MuiInputBase-root": {
			borderRadius: "14px !important",
			background: "var(--atl-surface-solid) !important",
			color: "var(--atl-text) !important",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "var(--atl-border) !important",
		},
		"& .MuiInputLabel-root": {
			color: "var(--atl-text-soft) !important",
			fontWeight: "750 !important",
		},
	},
	dialogRoleTools: {
		display: "grid",
		gridTemplateColumns: "minmax(0, 1fr) auto",
		alignItems: "flex-start",
		gap: theme.spacing(1),
		[theme.breakpoints.down("sm")]: {
			gridTemplateColumns: "1fr",
		},
	},
	solidMenuPaper: {
		background: "var(--atl-surface-solid) !important",
		color: "var(--atl-text) !important",
		border: "1px solid var(--atl-border) !important",
		boxShadow: "var(--atl-shadow) !important",
		backdropFilter: "none !important",
		WebkitBackdropFilter: "none !important",
	},
	dialogActions: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "flex-end",
		gap: theme.spacing(1),
	},
	dialogButton: {
		borderRadius: "999px !important",
		textTransform: "none !important",
		fontWeight: "850 !important",
	},
}));
